exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdp-price-module[data-v-83cf3792] {\n  padding: 1.5em 0;\n  border-top: 1px solid #ebebeb;\n  border-bottom: 1px solid #ebebeb;\n}\n.pdp-price-module .one-time-price[data-v-83cf3792] {\n  border-right: 1px solid #ebebeb;\n  padding-right: 1em;\n}\n", ""]);

// exports
